import script from "./ModalVincularPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVincularPerfil.vue?vue&type=script&setup=true&lang=js"

import "./ModalVincularPerfil.vue?vue&type=style&index=0&id=4dd3ef44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd3ef44"]])

export default __exports__